// TODO: still requires some refactoring.
import React from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Tooltip, TrevorIcon } from '@trevor/ui-components';
import {
  DATASOURCES_URL_PATH,
  SETTINGS_URL_PATH,
  SETUP_URL_PATH,
} from '@/routing/paths';
import DropdownItem from '@/util/DropdownItem';
import MultiDropdown from '@/components/MultiDropdown';
import DropdownButton from '@/components/DropdownButton';
import { useDatasourceId, useToggle } from '@/hooks';
import {
  getIsAdmin,
  getIsConfigureEnabled,
  getIsGuest,
  getIsSelfHosted,
  getUserEmail,
} from '@/store-selectors';
import { loadHideTables, logout as logoutAction } from '@/actions';
import { useAppDispatch } from '@/store/hooks';
import { DropDownItemWithIcon, SideBarButton } from './SettingsItem.styles';

const divider = DropdownItem.divider();

export const SettingsItem = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();

  const isSelfHosted = useSelector(getIsSelfHosted);
  const isAdmin = useSelector(getIsAdmin);
  const isGuest = useSelector(getIsGuest);
  const isConfigureEnabled = useSelector(getIsConfigureEnabled);
  const userEmail = useSelector(getUserEmail);

  const [isOpen, toggleOpen] = useToggle(false, true);

  const isSettingsView = !!useMatch(SETTINGS_URL_PATH);
  const isCredentialsSetupView = !!useMatch(SETUP_URL_PATH);
  const isActive = isSettingsView || isCredentialsSetupView;

  const navigateToSettings = () =>
    navigate(`/datasources/${datasourceId}/settings`);
  const navigateToDatasources = () => navigate(DATASOURCES_URL_PATH);
  const navigateToBilling = () =>
    navigate(`/datasources/${datasourceId}/billing`);

  const handleOpenOldConfigure = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(loadHideTables());
  };

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(logoutAction());
  };

  const settings = DropdownItem.action(
    <DropDownItemWithIcon>
      <TrevorIcon name="settings" />
      Settings
    </DropDownItemWithIcon>,
    navigateToSettings,
  );

  const datasourcesLink = DropdownItem.action(
    <DropDownItemWithIcon>
      <TrevorIcon name="arrow-left" />
      Datasources
    </DropDownItemWithIcon>,
    navigateToDatasources,
  );

  const billing =
    !isAdmin || isSelfHosted
      ? null
      : DropdownItem.action(
          <DropDownItemWithIcon>
            <TrevorIcon name="credit-card" />
            Billing
          </DropDownItemWithIcon>,
          navigateToBilling,
        );

  const oldConfigure =
    !isAdmin || isConfigureEnabled
      ? null
      : DropdownItem.action(
          <span>
            <span
              className="glyphicon glyphicon-ban-circle share-gly"
              aria-hidden="true"
            />
            Hide tables / columns
          </span>,
          handleOpenOldConfigure,
        );

  const logout = DropdownItem.action(
    <DropDownItemWithIcon>
      <TrevorIcon name="power" />
      Logout
      <small className="faint" style={{ marginLeft: '8px' }}>
        {userEmail}
      </small>
    </DropDownItemWithIcon>,
    handleLogout,
  );

  const items = [
    ...(isGuest ? [] : [settings]),
    billing,
    oldConfigure,
    datasourcesLink,
    divider,
    logout,
  ];

  return (
    <DropdownButton
      onToggleOpen={toggleOpen}
      contentBuilder={() => (
        // @ts-expect-error: TODO: use new Dropdown.
        <MultiDropdown items={items} style={{ left: '30px' }} />
      )}
    >
      <span>
        <SideBarButton data-tooltip-id="settings" active={isActive}>
          <TrevorIcon name="settings" size="md" />
        </SideBarButton>
        {!isOpen && (
          <Tooltip id="settings" place="right">
            Tools & Settings
          </Tooltip>
        )}
      </span>
    </DropdownButton>
  );
};
